import { Grid, rem, Select } from "@mantine/core";
import { Fragment } from "react";
import { StyledGridCol } from "src/components/pages/Summary/VerifyEntries/VerifyEntries.styled";
import { useTheme } from "src/hooks";
import { type ICheckList, type SetChecklist } from "src/interfaces";

import { useSelector } from "../../../redux/hooks";
import ChecklistListRow from "./ChecklistListRow";
import { checklistTypes, EChecklistType } from "./checklists.utils";
import { Flex } from "../../../styled";
import LocalSearch from "../../../components/shared/LocalSearch/LocalSearch";

interface Props {
  data: ICheckList[] | undefined;
  defaultData: ICheckList[] | undefined;
  setSearchedData: (data: ICheckList[]) => void;
  setCheckList: SetChecklist;
  loading: boolean;
  currentLbid: string | undefined;
  refetch: () => void;
  disableCopy: boolean;
  checklistType: EChecklistType | null;
  setChecklistType: (type: EChecklistType) => void;
  resetSearch: number;
  setResetSearch: (resetSearch: number) => void;
}

const headers = [
  { label: "Name", colSpan: 8 },
  { label: "Version", colSpan: 1 },
  { label: "", colSpan: 2 },
];

const CheckListsList = ({
  data,
  checklistType,
  setChecklistType,
  setSearchedData,
  defaultData,
  resetSearch,
  setResetSearch,
  ...props
}: Props) => {
  const theme = useTheme();
  const { areChecklistsDisabled } = useSelector(state => state.permsSlice);

  return (
    <Flex direction="column" gap={rem(20)}>
      <Flex gap={2} align="flex-end">
        {checklistType && (
          <Select
            value={checklistType}
            onChange={setChecklistType}
            label="Checklist Type"
            data={checklistTypes}
            w={200}
          />
        )}
        <LocalSearch
          setData={setSearchedData}
          defaultData={defaultData}
          searchByProperty="name"
          resetSearch={resetSearch}
          setResetSearch={setResetSearch}
        />
      </Flex>

      <Flex direction="column" gap={rem(24)} mx={8} pb={rem(8)}>
        <Grid
          px={2}
          style={{
            color: theme.colors.thColor[0],
            backgroundColor: theme.colors!.thBackgroundColor![0],
            borderRadius: 12,
            minHeight: 44,
          }}>
          {headers.map((c, i) => (
            <StyledGridCol
              color=""
              span={c.colSpan}
              align="center"
              justify=""
              key={`checklist-header-${i}`}>
              {c.label}
            </StyledGridCol>
          ))}
        </Grid>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: rem(24),
          }}>
          {data && data.length > 0 ? (
            data.map(
              (c, i) =>
                !c.hidden && (
                  <ChecklistListRow
                    key={`checkist-lb-${i}`}
                    row={c}
                    disabled={areChecklistsDisabled}
                    {...props}
                  />
                ),
            )
          ) : (
            <div style={{ textAlign: "center" }}>
              {checklistType === EChecklistType.PROGRESS
                ? "There are no outstanding Checklists for completion"
                : "There is no matching checklists"}
            </div>
          )}
        </div>
      </Flex>
    </Flex>
  );
};

export default CheckListsList;
